import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { EditPolicyPermissionsController } from "../config/controllers/edit-policy-permissions-controller";

export function RLSecurityTableRow() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/security-table-row.html"),
        replace: true,
        controller: RLSecurityTableRowController,
        controllerAs: "strVM",
        bindToController: true,
        require: ["rlSecurityTableRow", "^ngController"],
        scope: {
            treeRow: "=rlSecurityTableRow"
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controllers: [RLSecurityTableRowController, EditPolicyPermissionsController]) => {
            controllers[0].tableCtrl = controllers[1];
            controllers[0].Init();


        }
    };
    return directive;
}

//interface IRLSecurityTableRowScope extends ng.IScope {
//    treeRow: Models.ISecurityTreeRow;
//}

class RLSecurityTableRowController {

    static $inject = ["$scope"];

    liClass: string;
    open: boolean;
    rightStatus: { [key: number]: number };
    effectiveStatus: { [key: number]: number };
    effectiveClass: { [key: number]: string };

    treeRow: Models.ISecurityTreeRow;
    tableCtrl: EditPolicyPermissionsController;


    constructor(private $scope: ng.IScope) {

        this.liClass = "fa-plus";
        this.rightStatus = {};
        this.effectiveStatus = {};
        this.effectiveClass = {};
    }


    Init() {
        var rowKey = this.treeRow.rowKey;
        this.open = this.treeRow.open;
        this.tableCtrl.RegisterPermissionChangedCallback(rowKey, () => this.RecalcRow());
        this.$scope.$on("$destroy", () => this.tableCtrl.RemovePermissionChangedCallback(rowKey));

        var effectivePermissionValue = this.tableCtrl.GetEffectivePermissionValue(this.treeRow);
        var permission = this.tableCtrl.FindPermission(this.treeRow);
        var actualPermissionValue = permission != null ? permission.permissionValue : 0;

        _.forEach(this.tableCtrl.securityRights, (securityRight) => {
            var rightFlag = securityRight.rightFlag;
            this.rightStatus[rightFlag] = Utils.SecurityUtil.GetRightStatus(actualPermissionValue, rightFlag);
            if (this.tableCtrl.showEffective) {
                this.effectiveStatus[rightFlag] = Utils.SecurityUtil.GetRightStatus(effectivePermissionValue, rightFlag);
                this.effectiveClass[rightFlag] = this.GetEffectiveStatusClass(this.effectiveStatus[rightFlag]);
            }
        });

        // when treeRows open changes
        this.$scope.$watch(() => this.treeRow.open, (newValue, oldValue) => {
            var open = newValue;
            var newClass = "";
            if (this.treeRow.node.childNodes.length > 0) {
                if (open) {
                    newClass = "fa-caret-down";
                } else {
                    newClass = "fa-caret-right";
                }
            } else {
                newClass = "";
            }
            this.liClass = newClass;
        });

        var parentOpenWatch = () => {
            var parentRow = this.treeRow.parentTreeRow;
            if (parentRow != null) {
                return parentRow.open;
            } else {
                return true;
            }
        };

        // watch when parent open state changes
        this.$scope.$watch(parentOpenWatch, (newValue, oldValue) => {
            if (!newValue) {
                this.treeRow.open = false;
            }
            this.open = newValue;
        });

        // when any permission changes
        //this.$scope.$watch(() => this.tableCtrl.policyPermissions,
        //    (newValue, oldValue) => {
        //        if (newValue != null) {

        //        }
        //    }, true);

        // when any permission changes
        //this.$scope.$watch(() => this.tableCtrl.policyPermissions,
        //    (newValue, oldValue) => {
        //        if (newValue != null) {
        //            this.RecalcRow();
        //        }
        //    }, true);

        this.RecalcRow();
    }

    RecalcRow() {

        //console.info(`recalcing ${this.treeRow.rowKey}`);
        this.effectiveStatus = {};
        this.effectiveClass = {};

        var permissionValue = 0;
        var permission = this.tableCtrl.FindPermission(this.treeRow);
        if (permission != null) {
            permissionValue = permission.permissionValue;
        }
        _.forEach(this.tableCtrl.securityRights, (securityRight) => {
            var rightFlag = securityRight.rightFlag;
            this.rightStatus[rightFlag] = Utils.SecurityUtil.GetRightStatus(permissionValue, rightFlag);
        });

        var effectivePermissionValue = this.tableCtrl.GetEffectivePermissionValue(this.treeRow);
        //var permission = this.tableCtrl.FindPermission(this.treeRow);
        var childPermissions: Models.IAspNetSecurityPolicyPermission[] = [];

        switch (this.tableCtrl.policyType) {
            case Consts.SecurityPolicyType.Activity:
                var childNodesIDs = this.tableCtrl.treeNodeChildMap[this.treeRow.node.securityActivityID];
                childPermissions = this.tableCtrl.policyPermissions.filter((p) => _.contains(childNodesIDs, p.securityActivityID));
                break;
            case Consts.SecurityPolicyType.Data:
                var checks: ((p: Models.IAspNetSecurityPolicyPermission | Models.ISecurityTreeNode) => number)[] = [
                    p => p.charTypeID,
                    p => p.templateGroupID,
                    p => p.templateID,
                    p => p.charGroupID,
                    p => p.charID
                ];

                var contextChecks = checks.filter(c => c(this.treeRow.node) != null);
                if (_.some(contextChecks)) {
                    childPermissions = this.tableCtrl.policyPermissions
                        .filter((p) => permission == null || !this.tableCtrl.MatchPermissions(p, permission))
                        .filter((p) => _.every(contextChecks, (c) => c(this.treeRow.node) == c(p)));
                } else if (_.every(checks, (c) => c(this.treeRow.node) == null)) {
                    childPermissions = this.tableCtrl.policyPermissions.filter((p) => permission == null || !this.tableCtrl.MatchPermissions(p, permission));
                }

                break;
            default:
                break;
        }


        _.forEach(this.tableCtrl.securityRights, (securityRight) => {
            var rightFlag = securityRight.rightFlag;
            this.effectiveStatus[rightFlag] = Utils.SecurityUtil.GetRightStatus(effectivePermissionValue, rightFlag);
            this.effectiveClass[rightFlag] = this.GetEffectiveStatusClass(this.effectiveStatus[rightFlag]);

            var denyFlag = rightFlag << 16;
            if (this.effectiveStatus[rightFlag] == Consts.AccessResult.Allow) {
                if (_.any(childPermissions, (p) => (p.permissionValue & denyFlag) == denyFlag)) {
                    this.effectiveClass[rightFlag] += " partial-stripe";
                }
            }
        });

    }

    GetEffectiveStatusClass(effectiveStatus: number) {
        var output = "effective-neutral";
        switch (effectiveStatus) {
            case 1:
                output = "success";
                break;
            case -1:
                output = "danger";
                break;
        }
        return output;
    }

    ToggleOpen() {
        this.treeRow.open = !this.treeRow.open;
        this.tableCtrl.CalculateVisibleRows();
    }

    Toggle(rightFlag: number) {
        this.tableCtrl.Toggle(this.treeRow, rightFlag);
    }
}
